module.exports = __webpack_public_path__ + "static/media/loader.7db9908f.png";